import Rete from 'rete'

const ivrSocket = new Rete.Socket('IVR')

export { ivrSocket }
